import { useMemo } from "react";
import { parseCssColorToHex } from "../utils/ctaAccentFromBrand";

/**
 * Builds optional CSS vars for branded CTA buttons.
 * Keeps fallback styles untouched when no valid brand colors exist.
 */
export function useBrandCtaVars(userData, logoSrc) {
  return useMemo(() => {
    if (!userData || typeof userData !== "object") {
      return { style: undefined, themed: false };
    }

    const btnHex = parseCssColorToHex(userData.button_color);
    const titleHex = parseCssColorToHex(userData.landing_page_title_color);
    const textHex = parseCssColorToHex(userData.button_text_color || userData.button_Textcolor);

    const style = {};
    if (btnHex) style["--cta-accent"] = btnHex;
    if (titleHex) style["--cta-title"] = titleHex;
    if (textHex) style["--cta-text"] = textHex;
    if (logoSrc && String(logoSrc).trim()) style["--cta-logo"] = `url("${String(logoSrc).trim()}")`;

    const themed = Object.keys(style).length > 0;
    return { style: themed ? style : undefined, themed };
  }, [userData, logoSrc]);
}
